import React, { useState } from "react";
import { Container, Card, Button, ListGroup } from "react-bootstrap";

const AdminSettings = () => {
  // Static settings options with state
  const [settings, setSettings] = useState([
    { id: 1, name: "Enable Dark Mode", enabled: false },
    { id: 2, name: "Allow User Registrations", enabled: true },
    { id: 3, name: "Enable Notifications", enabled: true },
    { id: 4, name: "Require 2FA for Admin Login", enabled: false },
  ]);

  // Toggle settings
  const toggleSetting = (id) => {
    setSettings(
      settings.map((setting) =>
        setting.id === id ? { ...setting, enabled: !setting.enabled } : setting
      )
    );
  };

  return (
    <Container className="py-4">
      <h1 className="text-center fw-bold mb-3">⚙️ Admin Settings</h1>
      <p className="text-center text-muted">Configure your admin panel settings and preferences.</p>

      {/* Settings List */}
      <Card className="shadow-sm mt-3">
        <Card.Body>
          <ListGroup variant="flush">
            {settings.map((setting) => (
              <ListGroup.Item key={setting.id} className="d-flex justify-content-between align-items-center">
                <span className="fw-semibold">{setting.name}</span>
                <Button
                  variant={setting.enabled ? "success" : "danger"}
                  onClick={() => toggleSetting(setting.id)}
                >
                  {setting.enabled ? "Enabled" : "Disabled"}
                </Button>
              </ListGroup.Item>
            ))}
          </ListGroup>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default AdminSettings;
